module.exports = __webpack_public_path__ + "img/term_life.16fcc9f6.svg";